<template>
  <div v-if="exhibition" class="form-container">
    <div style="margin-left: 150px">
      <el-tabs class="tfam-custom-tabs" v-model="currentLang">
        <el-tab-pane
          v-for="(lang) in langList"
          :key="lang['language_key']"
          :label="lang['title']"
          :name="lang['language_key']"></el-tab-pane>
      </el-tabs>
    </div>
    <el-form ref="form" :model="exhibition" label-width="150px" label-position="left">
      <el-form-item label="展覽名稱">
        <el-input v-model="exhibition[currentLang].title"></el-input>
      </el-form-item>
      <el-form-item label="完整展覽名稱">
        <el-input v-model="exhibition[currentLang].full_title"></el-input>
      </el-form-item>
      <el-form-item label="展覽時間">
        <el-row class="range-content">
          <el-date-picker
            v-model="exhibition.open_start_at"
            type="date"
            placeholder="YYYY/MM/DD"
            format="yyyy/MM/dd"></el-date-picker>
          <span class="divider">－</span>
          <el-date-picker
            v-model="exhibition.open_end_at"
            type="date"
            placeholder="YYYY/MM/DD"
            format="yyyy/MM/dd"></el-date-picker>
        </el-row>
      </el-form-item>
      <el-form-item label="策展人">
        <el-tooltip class="item" effect="dark" content='可透過直接輸入格式 "中文(空格)英文" EX.陳順築 Chen, Shun-Zhu' placement="top">
          <curator-select
            :select-artists="exhibition.curators"
            propName="curators"
            place-holder-text="選擇策展人"
            @update="updateCurators"
            :update-artist="updateArtistList"
          ></curator-select>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="協同策展人">
        <el-tooltip class="item" effect="dark" content='可透過直接輸入格式 "中文(空格)英文" EX.陳順築 Chen, Shun-Zhu' placement="top">
          <curator-select
            :select-artists="exhibition.co_curators"
            place-holder-text="選擇協同策展人"
            propName="co_curators"
            :update-artist="updateArtistList"
            @update="updateCurators"
          ></curator-select>
        </el-tooltip>
      </el-form-item>
      <!--
      <el-form-item label="使用展間">
        <room-selector
          :selected-rooms="exhibition.rooms"
        ></room-selector>
      </el-form-item>
      -->
      <el-form-item label="封面圖片">
        <div class="image-content exhibition-image demo-image__error">
          <div class="block">
            <el-image :src="getExhibitionImage()" fit="cover">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </div>
        <input id="fileInput" type="file" @change="onImagesChange" accept="image/jpeg, image/png" hidden>
        <div style="margin-top: 20px">
          <el-button @click="handleUploadImage">{{ exhibition.images.length > 0 ? exhibition.images[0]['original_name'] : '選擇檔案' }}</el-button>
          <el-button v-if="uploadImages.length > 0" plain @click="removeUploadImage">移除所選檔案</el-button>
        </div>
      </el-form-item>
      <!--
      <el-form-item label="語音導覽">
        <el-button plain>{{ exhibition[currentLang].audio && exhibition[currentLang].audio.length > 0 ? exhibition[currentLang].audio : '選擇檔案' }}</el-button>
      </el-form-item>
      -->
      <el-form-item label="強制使用耳機">
        <el-checkbox v-model="exhibition.force_bluetooth_headphone">聆聽語音導覽時強制使用耳機（藍牙或有線）</el-checkbox>
      </el-form-item>
      <el-form-item label="簡介">
        <el-input
          type="textarea"
          :autosize="{ minRows: 5 }"
          v-model="exhibition[currentLang].introduction"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="tfam-button" plain v-loading.fullscreen.lock="fullLoading" @click="handleSubmitUpdate">更新並儲存</el-button>
        <el-button class="tfam-button" plain @click="goBack">返回至上一層</el-button>
        <el-button class="tfam-button" plain @click="deleteRowData">捨棄這筆資料</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { fetchExhibition, createExhibition, updateExhibition,
  createExhibitionLang, updateExhibitionLang, deleteExhibitionWithCollection } from "../../api/exhibition";
import { fetchFloorList } from "../../api/floor";
import { fetchArtistList, createArtist, createArtistLang } from "../../api/artist";
import { storageUploadFiles, getGCPFileUrl } from "../../api/attachment";
import { deleteCollection } from "../../api/collection";
import CuratorSelect from "../Componments/CuratorSelect";
import { createImage, deleteImage } from "../../api/image";
import lodash from 'lodash'
import RoomSelector from "../Componments/RoomSelector";

export default {
  name: "ExhibitionEdit",
  components: {RoomSelector, CuratorSelect},
  data() {
    return {
      isOlder: this.$route.params.version === 'v1',
      currentLang: 'ZH_TW',
      langList: this.$store.getters.langList,
      exhibition: undefined,
      exhibitionId: undefined,
      originalExhibition: undefined,
      fullLoading: true,
      uploadImages: [],
      updateArtistList: new Date().getTime()
    }
  },
  methods: {
    updateCurators(val) {
      this.exhibition[val['propName']] = val['data'];
    },
    getExhibitionImage() {
      if (this.uploadImages.length > 0) {
        return this.exhibition.images[0]['file'];
      } else {
        if (this.exhibition.images.length > 0) {
          return getGCPFileUrl(this.exhibition.images[0]['name']);
        } else {
          return ''
        }
      }
    },
    onImagesChange(event){
      const files = event.target.files;
      if (files) {
        const files_count = files.length;
        for (let i = 0; i < files_count; i++){
          const reader = new FileReader();
          reader.onload = (e) => {
            this.exhibition['images'] = [];
            this.exhibition['images'] = [{
              file: e.target.result,
              name: files[i]['name'],
              original_name: files[i]['name']
            }];
            this.uploadImages = files;
          };
          reader.readAsDataURL(files[i]);
        }
      }
    },
    handleUploadImage() {
      document.getElementById("fileInput").click()
    },
    removeUploadImage() {
      this.exhibition.images = lodash.cloneDeep(this.originalExhibition.images);
      this.uploadImages = [];
      if (document.getElementById("fileInput")) {
        document.getElementById("fileInput").value = '';
      }
    },
    getExhibitionData() {
      this.exhibition = undefined;
      this.uploadImages = [];
      if (document.getElementById("fileInput")) {
        document.getElementById("fileInput").value = '';
      }
      const filter = {
        include: ['exhibitionLangs', 'collections']
      };
      this.fullLoading = true;
      fetchExhibition(this.exhibitionId, filter).then(response => {
        const data = response.data;
        const exhibitionData = Object.assign({}, data);
        // 舊展覽資料可能為 null，先補成 boolean 讓 checkbox 能正確綁定
        exhibitionData.force_bluetooth_headphone = data.force_bluetooth_headphone === true;
        for (const i in this.langList) {
          const lang = this.langList[i]['language_key'];
          exhibitionData[lang] = {};
          const filter = data['exhibitionLangs'].filter(x => x['language_key'] === lang);
          if (filter.length > 0) {
            exhibitionData[lang].exhibition_lang_id = filter[0]['exhibition_lang_id'];
            exhibitionData[lang].language_key = lang;
            exhibitionData[lang].title = filter[0]['title'];
            exhibitionData[lang].full_title = filter[0]['full_title'];
            exhibitionData[lang].introduction = filter[0]['introduction'];
            exhibitionData[lang].audio = filter[0]['audio'];
          } else {
            exhibitionData[lang].exhibition_lang_id = 'new';
            exhibitionData[lang].language_key = lang;
            exhibitionData[lang].title = '';
            exhibitionData[lang].full_title = '';
            exhibitionData[lang].introduction = '';
            exhibitionData[lang].audio = '';
          }
        }
        this.exhibition = Object.assign({}, exhibitionData);
        this.originalExhibition = Object.assign({}, exhibitionData);
        this.fullLoading = false;
      }).catch(e => {
      })
    },
    handleSubmitUpdate() {
      this.fullLoading = true;
      this.submitUpdate().then(response => {
        this.fullLoading = false;
        this.$message({
          type: 'success',
          message: '儲存成功!'
        });
        if (this.$route.params.id === 'new') {
          this.exhibitionId = response['exhibitionId'];
          this.$router.push({
            path: '/exhibitions/v2/' + this.exhibitionId
          });
        }
        this.getExhibitionData();
        if (response['updateNewArtist']) {
          this.updateArtistList = new Date().getTime();
        }
      }).catch(err => {
        console.log(err);
        let message = err;
        if (err.response) {
          message = err.response.data.error.message + '!'
        }
        this.$alert(message, '儲存失敗', {
          confirmButtonText: '確定',
          callback: action => {
          }
        });
        this.fullLoading = false;
      })
    },
    submitUpdate: async function() {
      try {
        let updateNewArtist = false;
        let exhibitionId = this.exhibition.exhibition_id;
        const exhibitionData = Object.assign({}, this.exhibition);
        const newCurator = [];
        for (const i in exhibitionData['curators']) {
          const curator = exhibitionData['curators'][i];
          if (curator.indexOf('建立') >= 0) {
            const date = new Date().getFullYear();
            const newArtist = await createArtist({ born: date});
            const name = curator.replace('建立 ', '');
            const nameSplit = name.split(' ');
            const artistLangZH = {
              artist_id: newArtist.data['artist_id'],
              language_key: 'ZH_TW',
              name: nameSplit[0]
            };
            const enName = nameSplit.slice(1);
            await createArtistLang(artistLangZH);
            const artistLangEN = {
              artist_id: newArtist.data['artist_id'],
              language_key: 'EN',
              name: enName.join(' ')
            };
            await createArtistLang(artistLangEN);
            newCurator.push(newArtist.data['artist_id']);
            updateNewArtist = true;
          } else {
            newCurator.push(curator);
          }
        }
        const newCoCurator = [];
        for (const i in exhibitionData['co_curators']) {
          const curator = exhibitionData['co_curators'][i];
          if (curator.indexOf('建立') >= 0) {
            const date = new Date().getFullYear();
            const newArtist = await createArtist({ born: date});
            const name = curator.replace('建立 ', '');
            const nameSplit = name.split(' ');
            const artistLangZH = {
              artist_id: newArtist.data['artist_id'],
              language_key: 'ZH_TW',
              name: nameSplit[0]
            };
            const enName = nameSplit.slice(1);
            await createArtistLang(artistLangZH);
            const artistLangEN = {
              artist_id: newArtist.data['artist_id'],
              language_key: 'EN',
              name: enName.join(' ')
            };
            await createArtistLang(artistLangEN);
            newCoCurator.push(newArtist.data['artist_id']);
            updateNewArtist = true;
          } else {
            newCoCurator.push(curator);
          }
        }
        exhibitionData['curators'] = newCurator;
        exhibitionData['co_curators'] = newCoCurator;
        delete exhibitionData.images;
        if (exhibitionId === 'new') {
          const newExhibition = await createExhibition(exhibitionData);
          console.log(newExhibition);
          exhibitionId = newExhibition.data['exhibition_id'];
        } else {
          await updateExhibition(exhibitionId, exhibitionData)
        }
        for (const i in this.langList) {
          const exhibitionLang = this.exhibition[this.langList[i]['language_key']];
          if (exhibitionLang['exhibition_lang_id'] === 'new') {
            exhibitionLang['exhibition_id'] = exhibitionId;
            await createExhibitionLang(exhibitionLang);
          } else {
            await updateExhibitionLang(exhibitionLang['exhibition_lang_id'], exhibitionLang);
          }
        }
        if (this.uploadImages.length > 0) {
          const uploadResult = await storageUploadFiles(this.uploadImages);
          const files = uploadResult.data.result.files.file;
          const fileName = files[0]['name'];
          const originalFilename = files[0]['originalFilename'];
          await createImage({
            name: fileName,
            original_name: originalFilename,
            object_id: exhibitionId
          });
          console.log(this.originalExhibition);
          if (this.originalExhibition.images.length > 0) {
            for (const i in this.originalExhibition.images) {
              const imageId = this.originalExhibition.images[i]['image_id'];
              await deleteImage(imageId);
            }
          }
        }
        return Promise.resolve({
          exhibitionId,
          updateNewArtist
        });
      } catch (e) {
        this.fullLoading = false;
        return Promise.reject(e);
      }
    },
    goBack() {
      this.$router.push({
        path: '/exhibitions'
      });
    },
    deleteRowData() {
      if (confirm('確定要捨棄這筆資料嗎？\n(捨棄的資料將無法復原。)')) {
        if (this.exhibition['exhibition_id'] === 'new') {
          this.goBack();
        } else {
          this.fullLoading = true;
          deleteExhibitionWithCollection(this.exhibition['exhibition_id']).then(response => {
            this.fullLoading = false;
            this.$router.push({
              path: '/exhibitions'
            })
          }).catch(err => {
            this.fullLoading = false;
          })
        }
      }
    }
  },
  mounted() {
    this.exhibitionId = this.$route.params.id;
    if (this.exhibitionId !== 'new') {
      this.getExhibitionData()
    } else {
      const exhibition = {
        exhibition_id: 'new',
        curators: [],
        co_curators: [],
        rooms: [],
        images: [],
        open_start_at: undefined,
        open_end_at: undefined,
        force_bluetooth_headphone: false
      };
      for (const i in this.langList) {
        const lang = this.langList[i]['language_key'];
        exhibition[lang] = {};
        exhibition[lang].language_key = lang;
        exhibition[lang].exhibition_lang_id = 'new';
        exhibition[lang].title = '';
        exhibition[lang].full_title = '';
        exhibition[lang].introduction = '';
        exhibition[lang].audio = '';
      }
      this.exhibition = exhibition;
      this.originalExhibition = lodash.cloneDeep(exhibition);
      this.fullLoading = false;
    }
  }
}
</script>

<style lang="scss">
.room-options {
  width: 100%;
}
.el-select {
  width: 100%;
}
.text-content {
  width: 100%;
  min-height: 40px;
  /*height: 70px;*/
  padding: 0 20px;
  background-color: white;
  /*margin: 10px 0;*/
  span {
    font-size: 14px;
    line-height: 40px;
    color: #222;
  }
}
  .el-select-dropdown {
    width: 500px !important;
  }
</style>
